export enum EventType {
  day_long = "Tagesveranstaltung",
  week_long = "Wochenveranstaltung",
}
